var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "account-settings-info-view"
  }, [_c('a-form', {
    attrs: {
      "layout": "vertical",
      "form": _vm.form
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "真实姓名",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['realname'],
      expression: "['realname']"
    }],
    attrs: {
      "disabled": "",
      "placeholder": "请输入真实姓名"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "证件号码",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['idcard'],
      expression: "['idcard']"
    }],
    attrs: {
      "disabled": "",
      "placeholder": "证件号码"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "证件照",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "ant-upload-preview",
    on: {
      "click": function click($event) {
        return _vm.$refs.photoModal.edit(1);
      }
    }
  }, [_c('a-icon', {
    staticClass: "upload-icon",
    attrs: {
      "type": "cloud-upload-o"
    }
  }), _c('div', {
    staticClass: "mask"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus"
    }
  })], 1), _vm.userInfo ? _c('img', {
    attrs: {
      "src": _vm.userInfo.photo_url
    }
  }) : _vm._e()], 1)]), _c('a-col', {
    staticClass: "photo-example",
    attrs: {
      "xs": 24,
      "md": 12
    }
  }, [_c('a-tag', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("蓝底一寸免冠照")]), _c('a-tag', {
    attrs: {
      "color": "orange"
    }
  }, [_vm._v("文件5MB以内")]), _c('img', {
    attrs: {
      "width": "180",
      "src": require("../../assets/photo-example.png"),
      "alt": "示例照片"
    }
  }), _c('h2', {
    staticClass: "tips"
  }, [_vm._v("示例照片")])], 1)], 1)], 1), _c('a-form-item', {
    attrs: {
      "label": "年级",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol
    }
  }, [_c('j-dict-select-tag', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['grade', _vm.validatorRules.grade],
      expression: "['grade', validatorRules.grade]"
    }],
    attrs: {
      "trigger-change": true,
      "dictCode": "grade",
      "placeholder": "请选择年级"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "性别",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol
    }
  }, [_c('a-radio-group', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['sex', _vm.validatorRules.sex],
      expression: "['sex', validatorRules.sex]"
    }]
  }, [_c('a-radio-button', {
    attrs: {
      "value": 1
    }
  }, [_vm._v(" 男 ")]), _c('a-radio-button', {
    attrs: {
      "value": 2
    }
  }, [_vm._v(" 女 ")])], 1)], 1), _c('a-form-item', {
    attrs: {
      "label": "邮箱",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['email', _vm.validatorRules.email],
      expression: "['email', validatorRules.email]"
    }],
    attrs: {
      "placeholder": "请输入邮箱"
    }
  })], 1), false ? _c('a-form-item', {
    attrs: {
      "label": "连接密码",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol,
      "required": false
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "h3gSbecd"
    }
  })], 1) : _vm._e(), false ? _c('a-form-item', {
    attrs: {
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol,
      "label": "登录密码",
      "required": false
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "密码"
    }
  })], 1) : _vm._e(), _c('a-form-item', {
    attrs: {
      "label": "手机号码",
      "labelCol": _vm.labelCol,
      "wrapperCol": _vm.wrapperCol
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['phone', _vm.validatorRules.phone],
      expression: "['phone', validatorRules.phone]"
    }],
    attrs: {
      "placeholder": "请输入手机号码"
    }
  })], 1), _c('a-form-item', [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("修改资料")])], 1)], 1), _c('PhotoModal', {
    ref: "photoModal",
    on: {
      "ok": _vm.photoChange
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };